import { render, staticRenderFns } from "./EMailChangeForm.vue?vue&type=template&id=23bf65f3&"
import script from "./EMailChangeForm.vue?vue&type=script&lang=js&"
export * from "./EMailChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports